<!--
  @description 业务拨测-详情
  @author xiehan
  @date 2018/12/03
-->
<template>
  <div class="dialDetail__content">
    <g-back :history="history"></g-back>
    <div class="chart-wrap">
      <el-form :inline="true">
        <el-form-item :label="$t('dial.time')" input-width="auto">
          <el-form-item>
            <el-date-picker value-format="timestamp" style="width: 180px;" v-model="chartForm.startTime" type="datetime">
            </el-date-picker>
          </el-form-item>
          <span v-text="$t('common.to')"></span>
          <el-form-item style="margin-left: 10px">
            <el-date-picker value-format="timestamp" style="width: 180px;" v-model="chartForm.endTime" type="datetime">
            </el-date-picker>
          </el-form-item>
        </el-form-item>
        <el-button type="primary" 
          @click="getChartData"
          v-text="$t('common.search')"
          v-g-rac="gRac('dialDetail_chartSearch')">
        </el-button>
      </el-form>
      <chart-base 
        ref="dialDetail" 
        chart-id="dialDetail" 
        type="AREA"
        :chart-data="chartData" 
        :chart-style="chartOpt"></chart-base>
      <div class="mt-base">
        <el-form :inline="true">
          <el-form-item :label="$t('dial.time')" input-width="auto">
            <el-form-item>
              <el-date-picker value-format="timestamp" style="width: 180px;" v-model="tableForm.startTime" type="datetime">
              </el-date-picker>
            </el-form-item>
            <span v-text="$t('common.to')"></span>
            <el-form-item style="margin-left: 10px">
              <el-date-picker value-format="timestamp" style="width: 180px;" v-model="tableForm.endTime" type="datetime">
              </el-date-picker>
            </el-form-item>
          </el-form-item>
          <el-form-item :label="$t('dial.result')">
            <el-select v-model="tableForm.status">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" 
            @click="e_searchTable"
            v-text="$t('common.search')"
            v-g-rac="gRac('dialDetail_tableSearch')">
          </el-button>
        </el-form>
      </div>
      <el-table-extend
        :data="tData" 
        :head="tHead" 
        :currentChange="tCurrentChange" 
        :sizeChange="tSizeChange" 
        border>
      </el-table-extend>
    </div>
  </div>
</template>
  
<script>
  import rac from '@/plugins/rac-mixin'
  import table from '@/components/mixins/table'
  import dialBiz from '@/logic/intelligentMonitor/dialBiz'
  import chartBase from '@/components/chart/chart-base.vue'
  import TimeFormat from '@/utils/timeFormat'
  import { extend } from '@/utils/tool'
  export default {
    mixins: [rac, table],
    data () {
      return {
        history: [],
        chartData: {},
        chartOpt: null,
        chartForm: {
          startTime: new Date(new Date().toLocaleDateString()).getTime(),
          endTime: ''
        },
        tableForm: {
          startTime: new Date(new Date().toLocaleDateString()).getTime(),
          endTime: '',
          status: true
        },
        options: [{
          value: true,
          label: this.$t('dial.success')
        }, {
          value: false,
          label: this.$t('dial.fail')
        }]
      }
    },
    components: {
      chartBase
    },
    methods: {
      setHistory () {
        this.history = []
        this.history.push({ name: this.$route.query.name })
      },
      getChartData () {
        dialBiz.getDetail({
          id: this.$route.query.id,
          startTime: this.chartForm.startTime
            ? this.chartForm.startTime : new Date(new Date().toLocaleDateString()).getTime(),
          endTime: this.chartForm.endTime ? this.chartForm.endTime : new Date().getTime()
        }).then(data => {
          this.setChartOpt()
          this.$nextTick(() => {
            this.drawChart(data)
          })
        })
      },
      setChartOpt () {
        this.chartOpt = {
          grid: {
            left: '3%',
            right: '3%',
            top: '6%',
            bottom: '3%',
            containLabel: true
          }
        }
      },
      drawChart (data) {
        this.chartData = {
          rows: data,
          columns: ['time', 'delay'],
          formatMap: {
            time: 'TIMELONG',
            delay: 'NUMBER-ms'
          },
          labelMap: {
            delay: this.$t('dial.delay')
          },
          seriesStyle: {
            lineStyle: {
              normal: {
                width: 1.6
              }
            },
            symbol: 'emptyCircle',
            smooth: true
          }
        }
      },
      initTable () {
        this.tInitTable({
          lanKey: 'dial.detailTable',
          head: ['time', 'name', 'result', 'delay', 'detail'],
          requestFun: this.searchTable,
          headOpt: {}
        })
      },
      e_searchTable () {
        this.tResetPage()
        this.searchTable()
      },
      searchTable () {
        const reqData = extend(true, { ...this.tPageInfo }, this.tableForm)
        reqData.startTime = reqData.startTime
          ? reqData.startTime : new Date(new Date().toLocaleDateString()).getTime()
        reqData.endTime = reqData.endTime
          ? reqData.endTime : new Date().getTime()
        reqData.id = this.$route.query.id
        dialBiz.getDetailList(reqData).then((data) => {
          if (data && data.dataList) {
            data.dataList.map(item => {
              item.time = TimeFormat.getFormatTime(item.time)
              item.result = item.result ? this.$t('dial.success') : this.$t('dial.fail')
              item.detail = String(item.detail)
              item.delay += 'ms'
            })
          }
          this.tData = data
        })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'dialDetail' && from.name === 'dial') {
          this.tableForm.status = true
          this.getChartData()
          this.setHistory()
          this.searchTable()
        }
      }
    },
    mounted () {
      this.getChartData()
      this.setHistory()
      this.searchTable()
      this.initTable()
    }
  }
</script>

<style scoped>
  .chart-wrap {
    width: 100%;
    height: 300px;
  }
</style>